import Vue from 'vue'
import App from './App'
import axios from 'axios'
import BaseMethod from "./util/baseMethod.js";
import VueI18n from 'vue-i18n'
import store from './store'

Vue.use(BaseMethod)
Vue.use(VueI18n)

const i18n = new VueI18n({
  messages: {}
})

const Domain = 'https://php-activity-api.meiamjsa11.com'
axios.defaults.baseURL = `${Domain}/FKLHJ/api/`
Vue.prototype.$axios = axios;
Vue.prototype.$Domain = Domain
Vue.config.productionTip = false

// 异步获取用户语言设置
async function initI18n() {
  try {
    // 调用接口获取用户语言偏好
     await axios.post('/FKLHJUser/checkActivity',{}).then( async res => {
      const { language_code } = res.data.data
      // 设置实际的语言
      i18n.locale =  language_code
      document.documentElement.setAttribute('lang', i18n.locale);
      // 如果需要动态加载语言包
      const messages = await import(`@/locales/${i18n.locale}.json`)
      i18n.setLocaleMessage(i18n.locale, messages.default)
    }).catch(err => {console.log(err)});
  } catch (error) {
    console.error('Failed to load language preference:', error)
  }
}

axios.interceptors.request.use(
  (config) => {
    // 动态设置 headers
    config.headers.lang = i18n.locale; // 你的语言获取逻辑
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

initI18n().then(() => {
  new Vue({
    i18n,
    store,
    render: h => h(App),
  }).$mount('#app')
})
